<template>
	<div :class="getIllustrationClass" v-scroll="handleScroll">
		<img :src="getIllustrationUrl" :alt="getIllustrationAlt">
	</div>
</template>

<script>

	export default {

		data: function() {
			return {
				scrolled: false,
			}
		},

		props: {
			name: {
				type: String,
				default: 'illustration',
			},

			fx: {
				type: Boolean,
				default: false,
			}

		},

		computed: {

			getIllustrationUrl: function() {

				return '/img/illustrations/' + this.name + '.svg'

			},

			getIllustrationClass: function() {

				var c = "illustration";

				if ( this.fx ) {

					c += ' fx';

				}

				if ( this.$data.scrolled ) {

					c += ' fx--on';

				}

				return c

			},

			getIllustrationAlt: function() {

				return this._translate('ui.icons.' + this.name);

			}

		},

		methods: {

	  	handleScroll: function(e, el) {

	  		if ( ! this.fx ) { return false; }

	    	var bounding = el.getBoundingClientRect();
				if ( (window.innerHeight - bounding.top) >= (window.innerHeight/3) ) {
					this.$data.scrolled = true;
				};

	  	}

		}

	}
</script>

<style lang="scss">

	.illustration {

		margin-bottom: 1rem;

		&.fx {
			opacity: 0;
			transform: translate3d(20px, 0, 0);
			transition: opacity 1s ease, transform 1.2s ease;

			@include mq('lap') {
				transform: translate3d(50px, 0, 0);
			}
		}

		&.fx--on {
			opacity: 1;
			transform: translate3d(0, 0, 0);
		}

		&.centered {

			img {

				display: block;
				margin-left: auto;
				margin-right: auto;

			}

		}

		&.large {
			height: 8rem;
		}

		img {

			display: inline-block;
			max-width: 100%;
			height: auto;

		}


	}

</style>